import { useState } from 'react';

/**
 * Client-side pagination over an in-memory list.
 * Returns the current page's items plus the props expected by the
 * search results components (FolderResults, MessageResults, ...).
 * @param {Array} items - Full list
 * @param {number} pageSize - Items per page
 */
export const usePagination = (items, pageSize) => {
    const [requestedPage, setRequestedPage] = useState(1);

    // Clamp so the page stays valid when the list shrinks (e.g. after a delete)
    const totalPages = Math.max(1, Math.ceil(items.length / pageSize));
    const page = Math.min(requestedPage, totalPages);
    const startIndex = (page - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize, items.length);

    return {
        pageItems: items.slice(startIndex, endIndex),
        totalCount: items.length,
        startIndex,
        endIndex,
        page,
        pageSize,
        onPageChange: (_, newPage) => setRequestedPage(newPage),
    };
};
